import axios from 'axios'
import store from '@/store'

const client = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/api/`,
  json: true
})

export const execute = (method, resource, data) => {
  const accessToken = localStorage.getItem('t')
  let needPrefix = !store.getters['account/isClient'] &&
    !['auth', 'dashboard'].includes(resource.split('/')[0])

  if (resource.includes('tzs')) {
    needPrefix = false
  }

  if (resource.includes('report/animalfeed/dashboard') && store.getters['account/isAdmin']) {
    needPrefix = false
  }

  if (resource.includes('leftovers') && (store.getters['account/isConsultant'] || store.getters['account/isStaff'])) {
    needPrefix = false
  }
  if (resource.includes('report/animalfeed/dashboard') && (store.getters['account/isConsultant'] || store.getters['account/isStaff'])) {
    needPrefix = false
  }

  const url = needPrefix
    ? `dashboard/clients/${store.getters.clientId}/${resource}`
    : resource
  return client({
    method,
    url,
    data,
    headers: {
      Authorization: `JWT ${accessToken}`
    }
  }).then(({ data }) => {
    return data
  }).catch(error => {
    if (error.response.status === 500) {
      store.dispatch('app/setServerErrorStatus', true)
    }
    return {
      errors: error.response.data.errors,
      status: error.response.status,
      error: true // used for some old logic
    }
  })
}
